import { getForms } from "../../../services/forms.services";
import { useEffect, useState } from "react";
import { IForms } from "../../../types/forms";
import ReactPagination from "../../Common/ReactPagination";
import Loading from "../../Common/LoadingScreen";
import { useNavigate } from "react-router-dom";
import Moment from "moment";
import deleteDataByID from "../../../services/delete.services";

import Modal from "react-modal";
import { jwtDecode } from "jwt-decode";
import downloadAsFiles from "../../../services/download.services";

export const SubscribeList = (): JSX.Element => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [Subscribe, setSubscribe] = useState<any>();
  const [limit, setLimit] = useState<number>(15);
  const [offset, setOffSet] = useState<number>(0);
  const [search, setSearch] = useState<string>("");
  const [buttonDisable, setButtonDisable] = useState<boolean>(false);

  const [selectedData, setSelectedData] = useState<any>([]);
  const [isSelectAllChecked, setIsSelectAllChecked] = useState<boolean>(false);

  const [deleteDataByIDModal, setDeleteDataByIDModal] = useState(false);
  const [dataID, setDataID] = useState();
  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const handleModal = () => setDeleteDataByIDModal(!deleteDataByIDModal);

  const deleteValue = (id: any, firstName: any, lastName: any) => {
    setFirstName(firstName);
    setLastName(lastName);
    setDataID(id);
  };

  const tokenInfo: any = jwtDecode(
    localStorage.getItem("access_token") as string,
  );

  const handleDelete = async (id: any) => {
    try {
      deleteDataByID(id);
      handleModal();
      getSubscribe();
    } catch (e: any) {
      if (!e.statusCode) {
        localStorage.removeItem("access_token");
        navigate("/");
      }
    }
  };

  useEffect(() => {
    getSubscribe();
  }, [offset, limit, search]);

  const getSubscribe = async () => {
    const getFormsArgs = {
      formTypeId: 1,
      limit: limit,
      offset: offset,
      name: search,
    };
    try {
      const allsubscribe = await getForms(getFormsArgs);
      setSubscribe(allsubscribe.data);
      setIsLoading(false);
    } catch (e: any) {
      if (!e.statusCode) {
        localStorage.removeItem("access_token");
        navigate("/");
      }
    }
  };

  useEffect(() => {
    const includes = Subscribe?.data.every((nrf: any) => {
      return selectedData?.some((selected: any) => selected.id === nrf.id);
    });

    includes ? setIsSelectAllChecked(true) : setIsSelectAllChecked(false);
  }, [Subscribe?.data]);

  const handleInput = (event: any) => {
    setSearch(event.target.value);
  };

  const handleDownload = async () => {
    setButtonDisable(true);
    const fileData = await downloadAsFiles("formTypeId=1");
    // const blob = new Blob([fileData.data], { type: 'text/csv;charset=utf-8;' });

    const selectedFileData = await downloadAsFiles(
      `formTypeId=1${selectedData
        .map((item: any) => `&selectedId=${item.id}`)
        .join("")}`,
    );

    let blob: any;
    if (selectedData) {
      blob = new Blob([selectedFileData.data], {
        type: "text/csv;charset=utf-8;",
      });
    } else {
      blob = new Blob([fileData.data], { type: "text/csv;charset=utf-8;" });
    }

    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", "SubscribeList.csv");
    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
    setButtonDisable(false);

    getSubscribe();
  };

  const handleChange = (e: any) => {
    const { id, checked } = e.target;

    let filteredCheckedData: any = [];
    let allCheckedData: any = [];

    if (id === "selectAll") {
      if (
        checked &&
        !Subscribe?.data.every((subcriber: any) => {
          return selectedData?.some(
            (selected: any) => selected.id === subcriber.id,
          );
        })
      ) {
        allCheckedData = [
          ...selectedData,
          ...Subscribe?.data.map((subcriber: any) => ({
            ...subcriber,
            // checked: true,
          })),
        ];
      } else if (
        !checked &&
        Subscribe?.data.every((subcriber: any) => {
          return selectedData?.some(
            (selected: any) => selected.id === subcriber.id,
          );
        })
      ) {
        allCheckedData = selectedData?.filter(
          (data: any) =>
            !Subscribe?.data.some(
              (subcriber: any) =>
                subcriber.id === data.id && subcriber.name === data.name,
            ),
        );
      }

      if (allCheckedData.length > 0) {
        filteredCheckedData = allCheckedData?.filter(
          (dataItem: any, index: any, self: any) =>
            index ===
            self.findIndex(
              (i: any) => i.id === dataItem.id && i.name === dataItem.name,
            ),
        );
        setSelectedData(filteredCheckedData);
      } else {
        setSelectedData(allCheckedData);
      }
      setIsSelectAllChecked(checked);
    } else {
      const updatedSelectedData = checked
        ? [
            ...selectedData,
            Subscribe?.data.find(
              (subcriber: any) => subcriber.id === Number(id),
            ),
          ]
        : selectedData?.filter((contact: any) => contact.id !== Number(id));

      // console.log('Updated Selected Data', updatedSelectedData);

      setSelectedData(updatedSelectedData);

      Subscribe?.data.every((subcriber: any) => {
        return updatedSelectedData?.some(
          (element: any) => element.id === subcriber.id,
        );
      })
        ? setIsSelectAllChecked(true)
        : setIsSelectAllChecked(false);
    }
  };

  return (
    <>
      <section className="main-container">
        <div className="top-section align-items-center row justify-content-between px-3">
          <div className="xlarge-text-size">Subscribe</div>
          <div className="d-flex col-md-8 justify-content-end px-0">
            <input
              value={search}
              onChange={handleInput}
              placeholder="Search by name"
              className="col-md-6 col-lg-4 col-xl-3"
            />
            {tokenInfo.permissions?.includes("Download") && (
              <button
                type="button"
                className="btn ml-3"
                onClick={handleDownload}
                disabled={buttonDisable}
              >
                Download{" "}
                {selectedData?.length === 0 ? "all" : selectedData?.length}
              </button>
            )}
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <div className="table-responsive">
              {isLoading && <Loading />}
              <table className="table">
                <thead>
                  <tr>
                    <th className="xs">
                      <input
                        type="checkbox"
                        id="selectAll"
                        onChange={handleChange}
                        checked={isSelectAllChecked}
                      />
                    </th>
                    <th className="xs">S.No.</th>
                    <th>Email</th>
                    <th>Email Status</th>
                    <th>Page Name</th>
                    <th className="sm">Source</th>
                    <th className="sm">Medium</th>
                    <th className="sm">Campaign</th>
                    <th className="sm">Content</th>
                    <th>Submitted on</th>
                    {tokenInfo.permissions?.includes("Delete") ? (
                      <th className="xs">Action</th>
                    ) : (
                      ""
                    )}
                  </tr>
                </thead>
                <tbody>
                  {Subscribe?.data === ""
                    ? "Empty data"
                    : Subscribe?.data.map((subscribe: IForms, index: any) => {
                        return (
                          <tr key={subscribe.id}>
                            <td>
                              <input
                                type="checkbox"
                                id={JSON.stringify(subscribe.id)}
                                checked={selectedData?.some(
                                  (item: any) => item.id === subscribe.id,
                                )}
                                onChange={handleChange}
                              />
                            </td>
                            <td>
                              <span>{index + offset + 1}</span>
                            </td>
                            <td>
                              <span>{subscribe.email}</span>
                            </td>
                            <td>
                              <span
                                className={`badge ${
                                  subscribe?.emailVerificationStatus?.toLowerCase() ??
                                  ""
                                }`}
                              >
                                {subscribe?.emailVerificationStatus?.toLowerCase() ??
                                  "-"}
                              </span>
                            </td>
                            <td>
                              <span>{subscribe.pageName}</span>
                            </td>
                            <td className="sm">
                              <span>{subscribe.utmSource}</span>
                            </td>
                            <td className="sm">
                              <span>{subscribe.utmMedium}</span>
                            </td>
                            <td className="sm">
                              <span>{subscribe.utmCampaign}</span>
                            </td>
                            <td className="sm">
                              <span>{subscribe.utmContent}</span>
                            </td>
                            <td className="sm">
                              <span className="">
                                {Moment(subscribe.createdAt).format(
                                  "ddd, MMM Do YYYY, h:mm:ss a",
                                )}
                              </span>
                            </td>
                            {tokenInfo.permissions?.includes("Delete") ? (
                              <>
                                <td className="xs">
                                  <button
                                    className="btn-danger btn"
                                    type="button"
                                    onClick={() => {
                                      handleModal();
                                      deleteValue(
                                        subscribe.id,
                                        subscribe.lastName,
                                        subscribe.firstName,
                                      );
                                    }}
                                  >
                                    Delete
                                  </button>
                                </td>{" "}
                              </>
                            ) : (
                              ""
                            )}
                          </tr>
                        );
                      })}
                </tbody>
              </table>
            </div>
            <ReactPagination
              totalData={Subscribe}
              setLimit={setLimit}
              setOffSet={setOffSet}
              limit={limit}
            />
          </div>
        </div>
      </section>

      <Modal
        isOpen={deleteDataByIDModal}
        onRequestClose={handleModal}
        contentLabel="delete-data"
      >
        <div className="head">
          <h4>Remove data</h4>
        </div>
        <div className="m-body">
          <div>
            Are you sure you want to remove this{" "}
            <b>
              {firstName} {lastName}
            </b>{" "}
            data
          </div>
        </div>
        <div className="m-footer">
          <button className="btn btn-link" onClick={handleModal}>
            Close
          </button>{" "}
          {"  "}
          <button
            className="btn btn-danger"
            onClick={() => handleDelete(dataID)}
          >
            Delete
          </button>
        </div>
      </Modal>
    </>
  );
};
